import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { TextKey } from '@mews-commander/enums';
import { getCheckedReservationIds } from '../../selectors';
import { selectionIsInquired as selectionIsInquiredSelector } from '../../selectors/reservationModuleState/reservationSelection';
import OptionalForm from '../OptionalForm';
import { formCardFactory } from '../formCardFactory';
import { fetchCurrentEnterpriseCheckedReservations } from '../../actions';
import { RESERVATION_BARE_MINIMUM_EXTENT } from '../../constants';

const INITIAL_VALUES = {
    sendEmail: true,
};
const OptionalFormCardElement = formCardFactory({
    FormElement: OptionalForm,
    titleTextKey: TextKey.Optional,
    onSuccessMessageKey: TextKey.OptionalReservationSuccessMessage,
    dataTestId: 'optional-form',
});
const OptionalFormCard = ({ selectionIsInquired, ...other }: $TSFixMe) => {
    if (!selectionIsInquired) {
        return null;
    }
    return <OptionalFormCardElement initialValues={INITIAL_VALUES} {...other} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        reservationIds: getCheckedReservationIds,
        selectionIsInquired: selectionIsInquiredSelector,
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        refetchGroup: () =>
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
            dispatch(fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_BARE_MINIMUM_EXTENT })),
    })
)(OptionalFormCard);
